import React from 'react';
import { Query } from 'react-apollo';
import DeleteJob from './components/DeleteJob'
import { Alert } from 'reactstrap';
import Mark from './components/MarkDone'
import { DIST_USER, POSTS_COUNT } from './components/queries'

const todosStyle = {
  marginTop: '20px'
}

const DashBoard = () => {

  return (
    <div>
      <div className="card">
        <div className="card-deck">
          <div className="card">
            <div className="main-section">
              <div className="dashbord dashbord-orange">
                <div className="icon-section">
                  <i className="fa fa-user" aria-hidden="true"></i><br />
                  <h4>Users</h4>

                  <Query query={DIST_USER}>
                    {({ loading, error, data }) => {
                      if (loading) return "Loading...";
                      if (error) return (console.log(error));
                      return (<h1>{data.users.users_agg.count} </h1>);
                    }}</Query>
                  <div className="detail-section">
                    <a href="#">More Info </a>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div className="card">
            <div className="main-section">
              <div className="dashbord dashbord-blue">
                <div className="icon-section">
                  <i className="fa fa-briefcase" aria-hidden="true"></i><br />
                  <h4>Posts</h4>

                  <Query query={POSTS_COUNT}>
                    {({ loading, error, data }) => {
                      if (loading) return "Loading...";
                      if (error) return (console.log(error));
                      return (<h1>{data.posts.posts_agg.count} </h1>);
                    }}</Query>

                  <div className="detail-section">
                    <a href="#">More Info </a>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div className="card">
            <div className="main-section">
              <div className="dashbord dashbord-green">
                <div className="icon-section">
                  <i className="fa fa-sticky-note" aria-hidden="true"></i><br />
                  <h4>Under Construction</h4>
                  <h1>coming soon..</h1>
                  <div className="detail-section">
                    <a href="#">More Info </a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <div>
          <ul> <h5>Features</h5>
            <li> Pay U Work is a simplified app and can get rid off Signing and Signup.</li>
            <li> It's free and you can post job and you will get direct contacts, we won't charge.</li>
          </ul>
        </div>
      </div>
    </div >
  )
}

export default DashBoard;
